let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1rmCE")).then(() => parcelRequire('5RCOn'));